/* clone-rv-header: mở/đóng drawer menu mobile + overlay + body.ravine-menu-open, mở submenu mobile */
if (!customElements.get('rv-header')) {
  class RvHeader extends HTMLElement {
    connectedCallback() {
      this.hamburger = this.querySelector('.ravine-header__hamburger');
      this.drawer = this.querySelector('.ravine-header__drawer');
      this.overlay = this.querySelector('[data-ravine-overlay]');
      this.closeBtn = this.querySelector('[data-ravine-close]');
      if (!this.hamburger || !this.drawer) return;

      this.onKeyup = (event) => {
        if (event.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close();
      };
      this.onResize = () => {
        if (window.innerWidth > 749 && this.drawer.classList.contains('is-open')) this.close(false);
      };

      this.hamburger.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keyup', this.onKeyup);
      window.addEventListener('resize', this.onResize);

      this.querySelectorAll('.ravine-header__mobile-toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const item = toggle.closest('.ravine-header__mobile-item');
          if (!item) return;
          const isOpen = item.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(isOpen));
        });
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.onKeyup);
      window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('ravine-menu-open');
    }

    open() {
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.overlay) this.overlay.classList.add('is-visible');
      this.hamburger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ravine-menu-open');
      if (this.closeBtn) window.setTimeout(() => this.closeBtn.focus(), 50);
    }

    close(returnFocus = true) {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) this.overlay.classList.remove('is-visible');
      this.hamburger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ravine-menu-open');
      if (returnFocus) this.hamburger.focus();
    }
  }

  customElements.define('rv-header', RvHeader);
}
